import axios from "axios";
import TokenService from "./token.service";
const siteConfig = require("../../configs/config.json");

const instance = axios.create({
  baseURL: siteConfig.api.invokeUrl,
  headers: {
    "Content-Type": "application/json",
  },
});


// API base URL loaded from config

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    // Token refresh mekanizması
    if (originalConfig && originalConfig.url !== "/auth/authenticate" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const refreshToken = TokenService.getLocalRefreshToken();
          if (refreshToken) {
            const rs = await instance.post("/auth/refreshtoken", {
              refreshToken: refreshToken,
            });

            const { accessToken } = rs.data;
            TokenService.updateLocalAccessToken(accessToken);

            // Update the authorization header
            originalConfig.headers["Authorization"] = 'Bearer ' + accessToken;

            return instance(originalConfig);
          }
        } catch (_error) {
          // Refresh token failed, redirect to login
          TokenService.removeUser();
          if (window.location.pathname !== '/sing-in') {
            window.location.href = '/sing-in';
          }
          return Promise.reject(_error);
        }
      }
    }

    if (err.response) {

      let errorMessage = 'Bir hata oluştu';
      // Server tarafından dönen hata
      switch (err.response.status) {
        case 400:
          errorMessage = 'Geçersiz istek';
          break;
        case 401:
          errorMessage = 'Yetkisiz erişim';
          // Token refresh başarısız olduysa zaten yukarıda yönlendirme yapıldı
          break;
        case 403:
          errorMessage = 'Erişim reddedildi';
          break;
        case 404:
          errorMessage = 'Kaynak bulunamadı';
          break;
        case 500:
          errorMessage = 'Sunucu hatası';
          break;
        default:
          errorMessage = `Bir hata oluştu (${err.response.status})`;


      }
      // Sadece 401 değilse veya retry yapıldıysa alert göster
      if (!originalConfig || err.response.status !== 401 || originalConfig._retry) {
        alert(errorMessage);
      }
    } else if (err.request) {
      alert('Sunucuya ulaşılamıyor');
    }




/*

    if (originalConfig.url !== "/auth/signin" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.post("/auth/refreshtoken", {
            refreshToken: TokenService.getLocalRefreshToken(),
          });

          const { accessToken } = rs.data;
          TokenService.updateLocalAccessToken(accessToken);

          return instance(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

 */

    return Promise.reject(err);
  }
);

export default instance;
